import { AxiosInstance } from 'axios';

import { CommitmentsAPIApiFactory } from '@cast/openapi';
import { CommitmentsAPIApiFactory as PricingCommitmentsAPIApiFactory } from '@cast/openapi-pricing';

import { AXIOS_CONFIGURATION } from '../constants';

export const CommitmentsApiAdapter = (client: AxiosInstance) => {
  const generatedApi = CommitmentsAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );
  const pricingGeneratedApi = PricingCommitmentsAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  return {
    getImportGCPCommitmentsScript:
      generatedApi.commitmentsAPIGetGCPCommitmentsImportScript,
    getCommitment: generatedApi.commitmentsAPIGetCommitment,
    getCommitments: generatedApi.commitmentsAPIGetCommitments,
    getCommitmentsUsageSummary:
      pricingGeneratedApi.commitmentsAPIGetUsageSummary,
    getCommitmentsUsageHistory:
      generatedApi.commitmentsAPIGetCommitmentUsageHistory,
    replaceAssignments: generatedApi.commitmentsAPIReplaceCommitmentAssignments,
    assignCommitment: generatedApi.commitmentsAPICreateCommitmentAssignment,
    updateCommitment: generatedApi.commitmentsAPIUpdateCommitment,
    batchUpdateCommitments: generatedApi.commitmentsAPIBatchUpdateCommitments,
    deleteCommitment: generatedApi.commitmentsAPIDeleteCommitment,
    deleteCommitments: generatedApi.commitmentsAPIBatchDeleteCommitments,
    getAssignments: generatedApi.commitmentsAPIGetCommitmentsAssignments,
    getCommitmentAssignments:
      generatedApi.commitmentsAPIGetCommitmentAssignments,
  };
};
